"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var VIDEO_PLAY = {
  HOVER: 'hover',
  AUTO: 'auto',
  ON_CLICK: 'onClick'
};
var _default = VIDEO_PLAY;
exports["default"] = _default;